var _style, _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolregioLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Tryb_izolacji",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 43.6 39.3",
    style: {
      enableBackground: "new 0 0 43.6 39.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#5D6770;}\r\n\t.st1{clip-path:url(#SVGID_2_);fill:#DA2128;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 43.6,
    height: 39.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,37.9H25v-1.2h1c0.4,0,0.8-0.2,1-0.5l0.5-0.7H25v-1.2h1.9c0.4,0,0.8-0.2,1-0.5l0.5-0.7l-4.8,0v6.1H28 v-0.9C28,38.1,27.8,37.9,27.6,37.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.2,36.1c0,1.1-0.8,1.9-1.8,1.9c-1.1,0-1.8-0.8-1.8-1.9c0-1.1,0.8-1.9,1.8-1.9C41.5,34.2,42.2,35,42.2,36.1  M40.4,33c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2C43.6,34.4,42.1,33,40.4,33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.7,36.1c0,1.1-0.8,1.9-1.8,1.9C7.8,38,7,37.2,7,36.1c0-1.1,0.8-1.9,1.8-1.9C9.9,34.2,10.7,35,10.7,36.1  M8.9,33c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.8,0,3.2-1.4,3.2-3.2C12,34.4,10.6,33,8.9,33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35,34.5v4.7h1.3v-6.1l-0.9,0.7C35.1,33.9,35,34.2,35,34.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.6,37.9h-2.4l0-3.4c0-0.3-0.1-0.6-0.4-0.8l-0.9-0.7v6.1H17v-0.9C17,38.1,16.8,37.9,16.6,37.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,36.3c0,0.3,0.2,0.5,0.5,0.5h0.6v0.9c-0.3,0.2-0.6,0.3-1,0.3c-1.1,0-1.8-0.8-1.8-1.9 c0-1.1,0.8-1.9,1.8-1.9c0.4,0,0.8,0.1,1.1,0.3c0.3,0.2,0.6,0.1,0.8-0.1l0.5-0.4L34,34c-0.6-0.7-1.5-1-2.3-1c-0.9,0-1.7,0.4-2.3,1 c-0.6,0.7-0.9,1.5-0.8,2.5c0.1,1.4,1.2,2.6,2.6,2.8c0.2,0,0.3,0,0.5,0c0.9,0,1.7-0.4,2.4-1l0,0v-2.5h-2.5V36.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.6,35.4c0,1-1.1,1.1-1.4,1.1H1.3v-2.2h0.8C2.8,34.3,3.6,34.6,3.6,35.4 M2.1,33.1H0v6.1h1 c0.2,0,0.4-0.2,0.4-0.4v-1h0.7c1.7,0,2.8-1,2.8-2.4C4.8,34,3.7,33.1,2.1,33.1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.4,35.4c0,1-0.9,1.1-1.3,1.1h-0.9v-2.1H20C20.7,34.3,21.4,34.6,21.4,35.4 M22.2,38.3 c-0.3-0.5-0.6-0.8-0.8-1c0.8-0.3,1.2-1,1.2-1.9c0-1.4-1.1-2.3-2.7-2.3h-2.1v6.1h1c0.2,0,0.4-0.2,0.4-0.4v-1.1h0.6 c0.6,0,0.7,0.1,1.2,0.8l0.2,0.3c0.1,0.2,0.3,0.3,0.5,0.3h1.2L22.2,38.3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.2,3.5h11.4c0.9,0,1.7-0.4,2.3-1.2L43.6,0H25.5C26.6,1,27.5,2.2,28.2,3.5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.2,8c0,0.6,0,1.1-0.1,1.7H35c0.9,0,1.7-0.4,2.3-1.2L39,6.2H29C29.1,6.8,29.2,7.4,29.2,8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.7,15.9h4.8c0.9,0,1.7-0.4,2.3-1.2l1.7-2.3h-6.2C27.7,13.7,26.8,14.9,25.7,15.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.1,0H0l1.7,2.4C2.3,3.1,3.1,3.5,4,3.5h11.7c2.1,0,5.3,1.2,6.2,5.1c-7-3-12.7,3.2-7.7,10.7l7.6,10.3l0.9-1.3 c0.7-1,0.7-2.4,0-3.4c0,0-0.9-1.2-5.3-7.3c-5-6.9,2.8-8,7.1-4.5c0.6-1.1,1-2.6,1-4.1C25.5,4.1,21.1,0,16.1,0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolregioLogo);
export default __webpack_public_path__ + "static/media/polregio-logo.7982042e61b8759270d9a3a0386cd65e.svg";
export { ForwardRef as ReactComponent };